import { Controller } from "@hotwired/stimulus"

// Manages active tab state for bottom navigation during Turbo Frame navigation
export default class extends Controller {
  static targets = ["tab"]

  activate(event) {
    const clickedTab = event.currentTarget

    this.tabTargets.forEach(tab => {
      tab.classList.remove("text-red-600")
      tab.classList.add("text-gray-500", "dark:text-gray-400")
    })

    clickedTab.classList.remove("text-gray-500", "dark:text-gray-400")
    clickedTab.classList.add("text-red-600")
  }
}
